import { render } from "./PendingItemResolution.vue?vue&type=template&id=9f6fc3aa"
import script from "./PendingItemResolution.vue?vue&type=script&lang=js"
export * from "./PendingItemResolution.vue?vue&type=script&lang=js"

import "./PendingItemResolution.vue?vue&type=style&index=0&id=9f6fc3aa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__